<template>
  <div id="notFound" class="notranslate">
    <h1 class="colorRed">404</h1>
    <h2 class="colorGrey">page not found</h2>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  created () {
    this.$store.dispatch('loading', false)
  }
}
</script>

<style lang="scss" scoped>
#notFound {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  padding: 0.3em 15px 8em;
  text-align: center;
  line-height: 1.3;
  transform: translate(0, -50%);
}
h1 {
  font-size: 3.2em;
  font-weight: bold;
  &:before {
    content: "\26A0";
    display: block;
    font-size: 3em;
    color: $color-lgrey;
    line-height: 1;
    opacity: 0.5;
  }
}
h2 {
  font-size: 1.1em;
}
</style>
